// apps/client/src/engine/systems.ts (M0-T09) — contracts §8.3 verbatim
export type SystemName = 'input' | 'movement' | 'netInterp' | 'animation' | 'interaction' | 'villagers' | 'camera' | 'render';
export const SYSTEM_ORDER: readonly SystemName[] =
  ['input', 'movement', 'netInterp', 'animation', 'interaction', 'villagers', 'camera', 'render'];
export interface Frame { now: number; dt: number; alpha: number; frameNo: number }   // now = synced town-clock ms
export interface System { readonly name: SystemName; update(frame: Frame): void }
